import { UserEvents, UserEventsAPI } from "../../lib/userEventsAPI";

/**
 * Save scroll area reference.
 * @param scrollArea
 */
export const saveScrollAreaRef = (scrollArea) => {
  window.famScrollArea = scrollArea;
};

/**
 * Track text selection change.
 */
let lastSelectionText = null;

export const trackTextSelection = (dispatch) => {
  const text = encodeURIComponent(window.getSelection().toString());
  lastSelectionText = text;

  // One trick to cope with these events firing for every different letter selected.
  setTimeout(() => {
    if (text && text === lastSelectionText) {
      dispatch(UserEventsAPI.send(UserEvents.TEXT_SELECTED, { text }));
    }
  }, 500);
};

/**
 * Track when user clicks on any link on the websit.
 * @param event
 */
export const trackLinkClick = (event) => (dispatch) => {
  const target = event.target;
  if (target.tagName === "A") {
    const text = target.innerHTML;
    const href = target.href;
    dispatch(UserEventsAPI.send(UserEvents.LINK_CLICKED, { text, href }));
  }
};
